export default __webpack_public_path__ + "static/media/mygivingVideoPoster.2245637b.png";